export default {
  paymentflow: {
    timeout: 1000 * 60 * 3.5,
    pollInterval: 1500,
    callbackUrl: (code: string) => `${import.meta.env.VITE_HOST}/${code}/callback`,
  },
  orderValidation: {
    timout: 15000,
    pollInterval: 500,
  },
};
